export default [
  {
    path: '/medical/home',
    redirect: '/v2/tj',//新版提交首页
    component: () => import('../page/medical/home')
  },
  /**
   * @param.id
   */
  {
    path: '/medical/info',
    component: () => import('../page/medical/info')
  },
  {
    path: '/medical',
    component: () => import('../page/medical/index')
  },
  /**
   * 选择日期
   * @query.team
   * @query.id
   * @query.compatId
   */
  {
    path: '/medical/date',
    component: () => import('../page/medical/date')
  },
  /**
   * @param.id
   */
  {
    path: '/medical/:id',
    component: () => import('../page/medical/detail')
  },
  /**
   * @param.id
   */
  {
    name: 'medicalPrepay',
    path: '/medical/:id/prepay',
    component: () => import('../page/medical/prepay')
  },
  /**
   * @param.id
   */
  {
    path: '/medical/:id/pay',
    component: () => import('../page/medical/pay')
  },
  /**
   * 院内套餐选择日期
   * @param.id
   */
  {
    path: '/medical/:id/yzdate',
    component: () => import('../page/medical/yzdate')
  },
  {
    path: '/medical/team/orders',
    component: () => import('../page/medical/team/orders.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/medical.js